export const CURRENT_COOKIE_CONSENT_VERSION = '2026-06-01';
